import { gql } from '@apollo/client';

export const CREATE_RESOURCE_METADATA = gql`
  mutation CreateResourceMetadata($input: CreateResourceMetadataRequest!) {
    createResourceMetadata(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        download_count
        master_list_resource
      }
    }
  }
`;

export const UPDATE_RESOURCE_METADATA = gql`
  mutation UpdateResourceMetadata($input: UpdateResourceMetadataRequest!) {
    updateResourceMetadata(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        download_count
        master_list_resource
      }
    }
  }
`;
